import { render, staticRenderFns } from "./DomainSecurity.vue?vue&type=template&id=69e881f8&scoped=true"
import script from "./DomainSecurity.vue?vue&type=script&lang=js"
export * from "./DomainSecurity.vue?vue&type=script&lang=js"
import style0 from "./DomainSecurity.vue?vue&type=style&index=0&id=69e881f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e881f8",
  null
  
)

export default component.exports